<template>
<div class="dashboard">
	<map-main-menu />
	<dash-sidebar />
	<router-view />
</div>
</template>

<script>
import MapMainMenu from '@/pages/mapPage/components/MapMainMenu'
import DashSidebar from './components/DashSidebar'

export default {
	components: {
		MapMainMenu,
		DashSidebar
	}
}
</script>

<style lang="scss">
.dashboard {
	.dashboard-page {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 112px;
		right: 0;
	}
}
</style>
